(function () {

    "use strict";

    angular
        .module('harriApp')
        .controller("SendToPOSModal", SendToPOSModal);

    SendToPOSModal.$inject = ['$scope', '$q', 'modalData', 'posIntegrationService', 'brandServices'];

    function SendToPOSModal($scope, $q, modalData, posIntegrationService, brandServices) {


        $scope.sendToPOSForm = new SendToToastForm($scope, $q, posIntegrationService, brandServices);

        var init = function () {
            $scope.sendToPOSForm.load(modalData.brandId, modalData.employees, modalData.teamStyle);
        };

        var submitForm = function () {
            $scope.sendToPOSForm.save()
                .then(function (result) {
                    modalData.onSuccess && modalData.onSuccess(result);
                    $scope.$hide();
                }).catch(function (err) {
                $scope.$hide();
            });
        };

        $scope.save = function () {
            if ($scope.sendToPOSForm.showConfirm) {
                Utils.hConfirm({
                    title: $filter("translate")("Warning: Unmapped Positions"),
                    text: $filter("translate")("Please note that some position(s) does not have a mapping to any toast position.")
                        + "<br><br>" +  $filter("translate")("Are you sure you want to proceed and only sync the mapped position(s).")  ,
                    callback: function (confirmed) {
                        if (confirmed) {
                            submitForm();
                        }
                    }
                });
            }
            else {
                submitForm();
            }
        };


        $scope.close = function () {
            $scope.$hide();
        };

        init();
    }
})();